
import {createComponentSimulation} from '@wixc3/simulation-core';
import {StylableButton} from '../../StylableButton';

export default createComponentSimulation({
  componentType: StylableButton,
  name: 'StylableButtonPreset37',
  readOnly: true,
  props: {
    label: 'stylable_button_preset_sale_vertical_gradient',
    svgId: '11062b_02290eaed40f429296d8efe7c9110b89.svg',
  },
});
